// removed by extract-text-webpack-plugin
module.exports = {"no-select":"no-select__3mdsn","pointer":"pointer__3ae-z","Header":"Header__MG3bN","UnreadNotis":"UnreadNotis__3p5DZ"};


//////////////////
// WEBPACK FOOTER
// ./routes/Chat/Header/style.scss
// module id = mBif
// module chunks = 0